import { API } from '@ospace/shared'
import { useQuery, UseQueryResult } from 'react-query'
import { Duration } from '@ospace/common'
import dayjs from 'dayjs'

type Opts = {
  clientId: number
  duration: Duration
  enabled?: boolean
}

export type StageStats = {
  count: number
  contactsCount: number
  companiesCount: number
  chart: Record<string, number>
}

export type LeadsStatsData = {
  discovery: StageStats
  lead: StageStats
  meetingBooked: StageStats
  opportunity: StageStats
  barChart: {
    month: string
    companies: number
    leads: number
    meetings: number
  }[]
}

export const useLeadsStats = (opts: Opts): UseQueryResult<LeadsStatsData> => {
  const { clientId, duration, enabled = true } = opts
  const startDate = duration?.segmentsDuration?.start
    ? dayjs(duration.segmentsDuration.start).format('YYYY-MM-DD')
    : undefined

  const endDate = duration?.segmentsDuration?.end
    ? dayjs(duration.segmentsDuration.end).format('YYYY-MM-DD')
    : undefined

  return useQuery({
    queryKey: ['client', clientId, 'leads-stats', startDate, endDate],
    queryFn: () =>
      API.get('client', `/clients/${clientId}/leads-stats`, {
        queryStringParameters: { startDate, endDate },
      }),
    enabled: enabled && !!startDate && !!endDate,
  })
}
